export const brokerHandover = {
  'broker_handover.page_title': 'Spojení s realitním specialistou',

  // SALE-GOAL STEP
  'broker_handover.sale_goal_step.stripe.title': 'Úspěšně odesláno.',
  'broker_handover.sale_goal_step.stripe.subtitle':
    'Váš odhad právě začínáme zpracovávat.',
  'broker_handover.sale_goal_step.title': 'Chcete prodat váš {estateType}?',
  'broker_handover.sale_goal_step.title.unknown':
    'Chcete prodat váší nemovitost?',
  'broker_handover.sale_goal_step.buyers.start':
    'Podobný {estateType} s námi aktuálně ',
  'broker_handover.sale_goal_step.buyers.start.unknown':
    'Podobnou nemovitost s námi aktuálně ',
  'broker_handover.sale_goal_step.buyers.count': 'hledá 65 zájemců',
  'broker_handover.sale_goal_step.findout': 'Zjistit zájem',
  'broker_handover.sale_goal_step.only_online_estimate':
    'Ne, děkuji stačí mi orientační odhad',

  // STATE STEP
  'broker_handover.state_step.title': 'Jak chcete zájemce oslovit?',
  'broker_handover.state_step.recommended': 'DOPORUČUJEME',
  'broker_handover.state_step.submit': 'Potvrdit',
  'broker_handover.state_step.back': 'Zpět',

  'broker_handover.state_step.complete_io.title': 'Okamžitý výkup',
  'broker_handover.state_step.complete_io.list.1': 'Prodáno již od 3 dnů',
  'broker_handover.state_step.complete_io.list.2': 'Kompletní servis',
  'broker_handover.state_step.complete_io.list.3': 'Nedosáhnete maximální ceny',

  'broker_handover.state_step.complete_broker.title': 'Přes makléře',
  'broker_handover.state_step.complete_broker.list.1': 'Maximální cena',
  'broker_handover.state_step.complete_broker.list.2': 'Kompletní servis',
  'broker_handover.state_step.complete_broker.list.3':
    'Délka prodeje 1-3 měsíce',

  'broker_handover.state_step.complete_self.title': 'Oslovím je sám',
  'broker_handover.state_step.complete_self.list.1':
    'Nedosáhnete maximální ceny',
  'broker_handover.state_step.complete_self.list.2':
    'O vše se musíte starat sami',
  'broker_handover.state_step.complete_self.list.3': 'Délka prodeje 3-6 měsíců',

  // BROKER STEP
  // sale goal - asap
  'broker_handover.broker_step.asap.flat.title':
    'Koupíme váš byt ihned, bez starostí a za férovou cenu',
  'broker_handover.broker_step.asap.house.title':
    'Koupíme váš dům ihned, bez starostí a za férovou cenu',
  'broker_handover.broker_step.asap.land.title':
    'Koupíme váš pozemek ihned, bez starostí a za férovou cenu',
  'broker_handover.broker_step.asap.other.title':
    'Koupíme vaši nemovitost ihned, bez starostí a za férovou cenu',
  'broker_handover.broker_step.asap.bullets.1': 'Získáte nabídku na výkup bytu',
  'broker_handover.broker_step.asap.bullets.2': 'Termín prodeje si určíte sami',
  'broker_handover.broker_step.asap.bullets.3':
    'Neřešíte prohlídky ani rekonstrukce',

  // sale goal - max-price
  'broker_handover.broker_step.max_price.title':
    'Prodejte za maximální cenu s ověřeným specialistou',
  'broker_handover.broker_step.max_price.bullets.1':
    'Získáte detailní odhad ceny',
  'broker_handover.broker_step.max_price.bullets.2':
    'Poradíme jak prodat nejlépe',
  'broker_handover.broker_step.max_price.bullets.3':
    'Oslovíme naši databázi kupců',

  'broker_handover.broker_step.floating_label': 'DOPORUČUJEME PŘED PRODEJEM',
  'broker_handover.broker_step.cta': 'Naplánovat termín schůzky',

  // DATE STEP
  'broker_handover.date_step.title': 'Vyberte preferovaný termín schůzky',

  // TIME STEP
  'broker_handover.time_step.title': 'Vyberte preferovaný čas schůzky',
  'broker_handover.time_step.option.morning': 'Dopoledne',
  'broker_handover.time_step.option.afternoon': 'Odpoledne',
  'broker_handover.time_step.option.evening': 'Večer',

  // CONFIRM STEP
  'broker_handover.confirm_step.title': 'Potvrzení schůzky',
  'broker_handover.confirm_step.goal': 'Téma schůzky',
  'broker_handover.confirm_step.goal.asap':
    'Jak prodat {estate} ihned, bez starostí a za férovou cenu',
  'broker_handover.confirm_step.goal.max_price':
    'Jak prodat {estate} za maximální cenu',
  'broker_handover.confirm_step.place': 'Místo schůzky',
  'broker_handover.confirm_step.date': 'Preferovaný termín schůzky',
  'broker_handover.confirm_step.length': 'Očekávaná délka schůzky',
  'broker_handover.confirm_step.length.content': '1 hodina',
  'broker_handover.confirm_step.cta': 'Potvrdit žádost o schůzku',

  'broker_handover.back': 'Zpět',
  'broker_handover.next': 'Další',
};
